/*
Because this function is used internally by DaysHoursMinutesSeconds, that one
could be used anywhere instead of this function, but I'll leave it for clearity.

These time formating functions would eventually be replaced with some library
probably. For now they are lean and simple.

@TODO Look into alternatives someday.
*/
function formatAsText(minutes, seconds) {
  if (minutes === 0) {
    return `${seconds} sec`;
  }
  return `${minutes} min`;
}

function formatAsClock(minutes, seconds) {
  const minutesStr = `${minutes}`;
  const secondsStr = `${seconds}`;

  // return `${minutesStr.padStart(2, '0')}:${secondsStr.padStart(2, '0')}`;
  return `${minutesStr}:${secondsStr.padStart(2, '0')}`;
}

export default function formatMinutesSeconds(seconds, options = {}) {
  const { useClockFormat } = options;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds - minutes * 60);

  return useClockFormat
    ? formatAsClock(minutes, remainingSeconds)
    : formatAsText(minutes, remainingSeconds);
}



// WEBPACK FOOTER //
// ./src/helpers/formatMinutesSeconds.js